<template>
  <el-row class="warp">
    <!-- <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }"><b>首页</b></el-breadcrumb-item>
        <el-breadcrumb-item>用户列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col> -->

    <el-col
      :span="24"
      class="warp-main"
      v-loading="loading"
      element-loading-text="拼命加载中"
    >
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
        <el-form :inline="true" :model="filters" ref="filters">
          <el-form-item label="登录账号" prop="name">
            <el-input
              v-model="filters.name"
              placeholder="登录账号"
              style="min-width: 15px"
              @keyup.enter.native="handleSearch"
            ></el-input>
          </el-form-item>
           <el-form-item label="手机号" prop="mobile">
            <el-input
              v-model="filters.mobile"
              placeholder="手机号"
              style="min-width: 180px"
              @keyup.enter.native="handleSearch"
            ></el-input>
          </el-form-item>
          <el-form-item label="所属店铺" prop="shopid">
            <el-select
              v-model.trim="filters.shopid"
              clearable
              filterable
              placeholder="请选择店铺(可搜索)"
            >
              <el-option
                v-for="item in shopList"
                :key="item.id"
                :label="item.shopname"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属角色" prop="roleid">
            <el-select
              v-model.trim="filters.roleid"
              clearable
              filterable
              placeholder="请选择角色(可搜索)"
            >
              <el-option
                v-for="item in roleList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="showAddDialog">添加</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetForm('filters')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <!--列表-->
      <el-table
        :data="users"
        highlight-current-row
        v-loading="loading"
        style="width: 100%"
      >
        <el-table-column label="序号" type="index" width="80">
        </el-table-column>
        <el-table-column prop="chinesename" label="用户姓名" width="120">
        </el-table-column>
        <el-table-column prop="loginname" label="登录账号" width="120">
        </el-table-column>
        <el-table-column prop="mobile1" label="手机号" width="120">
        </el-table-column>
        <!-- <el-table-column prop="wxaccount" label="微信账号" width="100" :formatter="formatSex" sortable>
        </el-table-column> -->
        <el-table-column prop="email" label="邮箱"> </el-table-column>
        <el-table-column prop="rolename" label="角色"> </el-table-column>
        <el-table-column prop="shopname" label="所属店铺" min-width="160">
        </el-table-column>
        <el-table-column prop="info" label="备注"> </el-table-column>
        <el-table-column label="操作" width="250">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="showEditDialog(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              @click="resetPwdDialog(scope.$index, scope.row)"
              >重置密码</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="removeUser(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="total, prev, pager, next"
          @current-change="handleCurrentChange"
          :page-size="10"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
      <!-- 添加界面 -->
      <el-dialog
        title="新增"
        :visible.sync="addFormVisible"
        :close-on-click-modal="false"
      >
        <el-form
          :model="addForm"
          label-width="80px"
          :rules="addFormRules"
          ref="addForm"
          show-overflow-tooltip
        >
          <el-form-item label="用户姓名" prop="chinesename">
            <el-input
              v-model="addForm.chinesename"
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="登录账号" prop="loginname">
            <el-input
              v-model="addForm.loginname"
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="loginpwd">
            <el-input
              v-model="addForm.loginpwd"
              type="password"
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile1">
            <el-input v-model="addForm.mobile1" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="英文名" prop="englishname">
            <el-input
              v-model="addForm.englishname"
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input type="email" v-model="addForm.email"></el-input>
          </el-form-item>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="所属店铺" prop="shopid">
                <el-select
                  v-model.trim="addForm.shopid"
                  clearable
                  filterable
                  placeholder="请选择(可搜索)"
                >
                  <el-option
                    v-for="item in shopList"
                    :key="item.id"
                    :label="item.shopname"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所属角色" prop="roleid">
                <el-select
                  v-model.trim="addForm.roleid"
                  clearable
                  filterable
                  placeholder="请选择(可搜索)"
                >
                  <el-option
                    v-for="item in roleList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="备注" prop="info">
            <el-input type="textarea" v-model="addForm.info"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button
            type="primary"
            @click.native="addSubmit"
            :loading="addLoading"
            >提交</el-button
          >
        </div>
      </el-dialog>
      <!-- 编辑界面 -->
      <el-dialog
        title="编辑"
        :visible.sync="editFormVisible"
        :close-on-click-modal="false"
      >
        <el-form
          :model="editForm"
          label-width="80px"
          :rules="editFormRules"
          ref="editForm"
          show-overflow-tooltip
        >
          <el-form-item label="用户姓名" prop="chinesename">
            <el-input
              v-model="editForm.chinesename"
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="登录账号" prop="loginname">
            <el-input
              v-model="editForm.loginname"
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="密码" prop="loginpwd">
            <el-input
              v-model="editForm.loginpwd"
              type="password"
              auto-complete="off"
            ></el-input>
          </el-form-item> -->
                    <el-form-item label="手机号" prop="mobile1">
            <el-input v-model="editForm.mobile1" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="英文名" prop="englishname">
            <el-input
              v-model="editForm.englishname"
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input type="email" v-model="editForm.email"></el-input>
          </el-form-item>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="所属店铺" prop="shopid">
                <el-select
                  v-model="editForm.shopid"
                  clearable
                  filterable
                  placeholder="请选择(可搜索)"
                >
                  <el-option
                    v-for="item in shopList"
                    :key="item.id"
                    :label="item.shopname"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所属角色" prop="roleid">
                <el-select
                  v-model="editForm.roleid"
                  clearable
                  filterable
                  placeholder="请选择(可搜索)"
                >
                  <el-option
                    v-for="item in roleList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="备注" prop="info">
            <el-input type="textarea" v-model="editForm.info"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button
            type="primary"
            @click.native="editSubmit"
            :loading="addLoading"
            >提交</el-button
          >
        </div>
      </el-dialog>
      <!-- 重置密码 -->
      <el-dialog
        title="重置密码"
        :visible.sync="pwdFormVisible"
        :close-on-click-modal="false"
      >
        <el-form
          :model="pwdForm"
          label-width="80px"
          :rules="pwdFormRules"
          ref="pwdForm"
        >
          <el-form-item label="用户姓名" prop="chinesename">
            <el-input v-model="pwdForm.chinesename" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="登录名" prop="loginname">
            <el-input v-model="pwdForm.loginname" :disabled="true"></el-input>
          </el-form-item>

          <el-form-item label="新密码" prop="loginpwd">
            <el-input v-model="pwdForm.loginpwd"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="pwdFormVisible = false">取消</el-button>
          <el-button
            type="primary"
            @click.native="pwdSubmit"
            :loading="pwdLoading"
            >提交</el-button
          >
        </div>
      </el-dialog>
    </el-col>
  </el-row>
</template>

<script>
import API from "../../../api/frbasicapi/user";
import { validateEMail,validatePhone } from "../../../utils/validators";

export default {
  data() {
    return {
      filters: {
        name: "",
        shopid: "",
        roleid: "",
        mobile:"",
      },
      loading: false,
      users: [],
      roles: [],
      roleIds: [],
      total: 0,
      page: 1,
      limit: 10,

      roleList: [],
      shopList: [],

      editFormVisible: false,
      editFormRules: {
        chinesename: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        loginname: [
          { required: true, message: "请输入登录名", trigger: "blur" },
        ],
        email: [{ validator: validateEMail }],
         mobile1: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: validatePhone },
        ],
        // password: [
        //   { required: true, message: "请输入密码", trigger: "blur" },
        //   { min: 5, max: 10, message: "长度在 5 到 10个字符" },
        //   {
        //     pattern: /^(\w){5,10}$/,
        //     message: "只能输入5-10个字母、数字、下划线",
        //   },
        // ],
        shopid: [{ required: true, message: "请选择店铺", trigger: "blur" }],
        roleid: [{ required: true, message: "请选则角色", trigger: "blur" }],
      },
      editForm: {
        loginname: "",
        loginpwd: "",
        chinesename: "",
        englishname: "",
        email: "",
        shopid: "",
        roleid: "",
        info: "",
      },

      //新增相关数据
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        chinesename: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        loginname: [
          { required: true, message: "请输入登录名", trigger: "blur" },
        ],
        email: [{ validator: validateEMail }],
        mobile1: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: validatePhone },
        ],
        loginpwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 5, max: 10, message: "长度在 5 到 10个字符" },
          {
            pattern: /^(\w){5,10}$/,
            message: "只能输入5-10个字母、数字、下划线",
          },
        ],
        shopid: [{ required: true, message: "请选择店铺", trigger: "blur" }],
        roleid: [{ required: true, message: "请选则角色", trigger: "blur" }],
      },
      addForm: {
        loginname: "",
        loginpwd: "",
        chinesename: "",
        englishname: "",
        email: "",
        shopid: "",
        roleid: "",
        info: "",
      },

      //重置密码相关
      pwdFormVisible: false,
      pwdLoading: false,
      pwdFormRules: {
          loginpwd: [
              {required: true, message: '请填写新的密码'},
              {min: 6, max: 12, trigger: 'blur', message: '密码长度为6到12位'},
              {
                  validator: (rule, value, callback) => {
                      if (!/(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{6,12}/.test(value)) {
                          callback(new Error('密码需包含字母数字和特殊符号！'))
                      } else {
                          callback()
                      }
                  }
              }
          ],
      },
      pwdForm: {},
    };
  },
  methods: {
    //性别显示转换
    formatSex: function (row, column) {
      return row.sex == 1 ? "男" : row.sex == 0 ? "女" : "未知";
    },
    handleCurrentChange(val) {
      this.page = val;
      this.search();
    },
    handleSizeChange(val) {
      this.limit = val;
      this.search();
    },
    handleSearch() {
      this.total = 0;
      this.page = 1;
      this.search();
    },
    //中心和角色下拉列表
    handleShopAndRole() {
      let that = this;
      API.getInfo().then(function (result) {
        if (0 === result.code) {
          that.shopList = result.data.listShop;
          that.roleList = result.data.listRole;
        } else {
          that.$message.error({
            showClose: true,
            message: result.msg || "新增失败",
            duration: 2000,
          });
        }
      });
    },
    //获取用户列表
    search: function () {
      let that = this;
      let params = {
        pageNum: that.page,
        pageSize: 10,
        name: that.filters.name,
        shopid: that.filters.shopid,
        roleid: that.filters.roleid,
        mobile:that.filters.mobile,
      };

      that.loading = true;
      API.getPageList(params)
        .then(
          function (result) {
            that.loading = false;
            if (result && result.data.totalSize) {
              that.total = result.data.totalSize;
              that.users = result.data.content;
            }
          },
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000,
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
    },
    showAddDialog: function () {
      this.addFormVisible = true;
      this.handleShopAndRole();
    },
    showEditDialog: function (index, row) {
      this.editFormVisible = true;
      this.handleShopAndRole();
      this.editForm = Object.assign({}, row);
    },
    resetPwdDialog: function (index, row) {
      this.pwdFormVisible = true;
      this.pwdForm = Object.assign({}, row);
      this.pwdForm.loginpwd = "";
    },
    addSubmit: function () {
      let that = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          that.loading = true;
          API.add(this.addForm).then(function (result) {
            if (0 === result.code) {
              that.loading = false;
              that.$message;
              that.$message.success({
                showClose: true,
                message: "新增成功",
                duration: 2000,
              });

            } else {
              that.$message.error({
                showClose: true,                
                // message: result.msg || "新增失败",
                message: result.message,
                duration: 2000,
              });
            }             
            that.$refs["addForm"].resetFields();
            that.addFormVisible = false;
            that.search();
          });
        }
      });
    },
    editSubmit: function () {
      let that = this;
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          that.loading = true;
          let params = Object.assign({}, that.editForm);
          API.update(params).then(function (result) {
            if (0 === result.code) {
              that.loading = false;
              that.$message;
              that.$message.success({
                showClose: true,
                message: "修改成功",
                duration: 2000,
              });
              that.$refs["editForm"].resetFields();
              that.editFormVisible = false;
              that.search();
            } else {
              that.$message.error({
                showClose: true,
                message: result.message,
                duration: 2000,
              });
            }
          });
        }
      });
    },
    removeUser: function (index, row) {
      let that = this;
      this.$confirm("确认删除该记录吗?", "提示", { type: "warning" })
        .then(() => {
          that.loading = true;
          API.delete({ id: row.id })
            .then(
              function (result) {
                that.loading = false;
                if (result && parseInt(result.code) === 0) {
                  that.$message.success({
                    showClose: true,
                    message: "删除成功",
                    duration: 1500,
                  });
                  that.search();
                }
              },
              function (err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000,
                });
              }
            )
            .catch(function (error) {
              that.loading = false;
              console.log(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000,
              });
            });
        })
        .catch(() => {});
    },
    pwdSubmit: function () {
      let that = this;
      this.$refs.pwdForm.validate((valid) => {
        if (valid) {
          that.loading = true;
          let params = {
            id: that.pwdForm.id,
            pwd: that.pwdForm.loginpwd,
          };
          API.pwd(params).then(function (result) {
            if (0 === result.code) {
              that.loading = false;
              that.$message;
              that.$message.success({
                showClose: true,
                message: "重置成功",
                duration: 2000,
              });
              that.$refs["pwdForm"].resetFields();
              that.pwdFormVisible = false;
              that.search();
            } else {
              that.$message.error({
                showClose: true,
                message: result.message,
                duration: 2000,
              });
            }
          });
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$nextTick(() => {});
    },
  },

  mounted() {
    this.handleSearch();
    this.handleShopAndRole();
  },
};
</script>

<style scoped>
</style>
